import { createSlice } from "@reduxjs/toolkit";
import { fetchDisputesItems } from "./DisputesThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const disputesSlice = createSlice({
  name: "disputes",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchDisputesItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDisputesItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchDisputesItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default disputesSlice.reducer;